import { render, staticRenderFns } from "./edit-catalogue-popup.vue?vue&type=template&id=6f09638a&scoped=true&"
import script from "./edit-catalogue-popup.vue?vue&type=script&lang=js&"
export * from "./edit-catalogue-popup.vue?vue&type=script&lang=js&"
import style0 from "./edit-catalogue-popup.vue?vue&type=style&index=0&id=6f09638a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f09638a",
  null
  
)

export default component.exports